import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AccueilComponent } from './accueil/accueil.component';
import { authGuard } from './authguard/auth.guard';
import { CorrespondanceComponent } from './correspondance/correspondance.component';
import { IncidentComponent } from './incident/incident.component';
import { AffranchiComponent } from './affranchi/affranchi.component';
import { ErreurCorrespondanceComponent } from './erreur-correspondance/erreur-correspondance.component';
import { StatsComponent } from './stats/stats.component';
import { OsCorrespondanceComponent } from './os-correspondance/os-correspondance.component';

export const routes: Routes = [
  { path: 'os-correspondance', component: OsCorrespondanceComponent, canActivate: [authGuard] },
  { path: 'stats', component: StatsComponent, canActivate: [authGuard] },
  { path: 'erreur-correspondance', component: ErreurCorrespondanceComponent, canActivate: [authGuard] },
  { path: 'correspondance', component: CorrespondanceComponent, canActivate: [authGuard] },
  { path: 'incident', component: IncidentComponent, canActivate: [authGuard] },
  { path: 'affranchi', component: AffranchiComponent, canActivate: [authGuard] },
  { path: 'accueil', component: AccueilComponent, canActivate: [authGuard] },
  { path: '', component: LoginComponent },
];
